import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"ProgressBar.vue"]])

export default __exports__